<template>
  <div class="container h-100">
    <div class="row h-100">
      <div class="col-lg-5 col-md-7 col-sm-9 col-xs-12 m-auto border rounded px-3 py-3 bg-light loginbox">
        <form @submit.prevent="resetPass()">
          <div class="row">
            <div class="col-md-12 text-center">
              <img :src="logoOscuro" class="mb-5"/>
            </div>
            <div class="col-md-12 form-group" v-if="error != ''">
              <p class="bg-danger text-light p-2 text-center rounded">{{ error }}</p>
            </div>
            <div class="col-md-12 form-group">
              <label>Introduzca el e-mail con el que se registró</label>
              <input type="email" v-model="email" class="form-control"/>
            </div>
            <div class="col-md-12 form-group text-right">
              <input v-if="!loading" type="submit" value="Recuperar contraseña" class="btn btn-primary"/>
              <button v-else class="btn btn-primary disabled" disabled>
                <font-awesome-icon icon="spinner" class="fa-spin"/> Enviando
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/util'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      error: '',
      email: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      nombreCorreduria: 'nombreCorreduria',
      direccionCorreduria: 'direccionCorreduria',
      urlBase: 'urlBase',
      logoOscuro: 'logoOscuro'
    })
  },
  methods: {
    resetPass() {
      if (!util.validateEmail(this.email)) {
        alert("El e-mail no es válido.")
        return
      }
      this.loading = true
      let url = this.urlBase + 'passwordcliente'
      let data = {
        email: this.email
      }
      let options = {}
      this.$http.post(url, data, options).then(
        (response) => {
          this.loading = false
          alert(response.body)
          this.$router.push({ name: 'login' })
        },
        (error) => {
          this.loading = false
          this.error = error.body.error.message
        }
      );
    }
  }
}
</script>

<style>

</style>
